module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAGQCAYAAABvWArbAAAAMElEQVQ4je3LIQ4AIBTD0O3f/8wrFgmKhMy8pKJKwkhSKeVbbGuAPU9f4PIopTxgAeS0DRtI4yK0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/orgChart/ui-bg_glass_65_ffffff_1x400.png
// module id = 1845
// module chunks = 0